export const CONTACT_LINK = {
  id: 'email',
  label: 'Email',
  href: 'mailto:ronitr.dev@gmail.com',
  icon: 'FiMail',
  ariaLabel: 'Email'
};

export const NAV_ITEMS = [
  {
    label: "Education",
    href: "#education",
    bgColor: "#2D1B3E",
    textColor: "#fff",
  },
  {
    label: "Experience",
    href: "#experience",
    bgColor: "#3A2456",
    textColor: "#fff",
  },
  {
    label: "Portfolio",
    href: "#projects",
    bgColor: "#4A3362",
    textColor: "#fff",
  }
];
